// eslint-disable-next-line no-undef
const clientId = GLOBAL_CONFIG.clientId;
// eslint-disable-next-line no-undef
const authority = GLOBAL_CONFIG.authority;
// eslint-disable-next-line no-undef
const redirectUri = GLOBAL_CONFIG.redirectUri;
const shopfront = GLOBAL_CONFIG.shopfrontScope;
const iBuyRequisition = GLOBAL_CONFIG.iBuyRequisitionScope;
const iBuySearch = GLOBAL_CONFIG.iBuySearchScope;
const iBuyCart = GLOBAL_CONFIG.iBuyCartScope;
const userProfile = GLOBAL_CONFIG.userProfileScope;
const sharedPreferences = GLOBAL_CONFIG.sharedPreferencesScope;

export const msalConfig = {
    auth: {
        clientId: clientId,
        authority: authority,
        redirectUri: redirectUri,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false, // Set to "true" if having issues on IE11 or Edge
    },
};

export const loginRequest = {
    scopes: [
        "email",
        "profile",
        "openid",
        "https://graph.microsoft.com/User.Read",
    ],
};
export const iBuyRequisitionsTokenRequest = {
    scopes: [iBuyRequisition],
};

export const iBuyCartTokenRequest = {
    scopes: [iBuyCart],
};

export const iBuySearchTokenRequest = {
    scopes: [iBuySearch],
};

export const userProfileRequest = {
    scopes: [userProfile],
};

export const tokenRequest = {
    scopes: [shopfront],
};
export const preferencesRequest = {
    scopes: [sharedPreferences],
};
